var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMusicNotesPlus = function SvgIconMusicNotesPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 2a1 1 0 0 1 1 1v1.25H21a1 1 0 1 1 0 2h-1.25V7.5a1 1 0 1 1-2 0V6.25H16.5a1 1 0 1 1 0-2h1.25V3a1 1 0 0 1 1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.875 12.5a3.625 3.625 0 1 0 3.625 3.625v-4.19a1 1 0 1 0-2 0v.949a3.6 3.6 0 0 0-1.625-.384m-1.625 3.625a1.625 1.625 0 1 1 3.25 0 1.625 1.625 0 0 1-3.25 0M6.5 15.884a3.625 3.625 0 1 0 2 3.241v-7.844l5.618-1.405a1 1 0 1 0-.486-1.94L8.5 9.22V6.782l3.76-.937a1 1 0 1 0-.483-1.94L7.258 5.03A1 1 0 0 0 6.5 6v9.884M4.875 17.5a1.625 1.625 0 1 0 0 3.25 1.625 1.625 0 0 0 0-3.25",
    clipRule: "evenodd"
  }))));
};
export default SvgIconMusicNotesPlus;